import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  Input,
  ElementRef,
  Inject,
} from "@angular/core";
import { OnboardingService } from "../../shared/service/onboarding.service";
import { ExitInterviews } from "../../shared/models/ExitInterviews";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatSortHeader, MatSort, MatDialog, MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { Router } from "@angular/router";
import {
  ConfirmDialogModel,
  ConfirmDialogComponent,
} from "../../shared/components/confirm-dialog/confirm-dialog.component";
import { UserService } from "../../shared/service/user.service";
import { EmployeeService } from "../../shared/service/employee.service";
import { ToastrService } from "ngx-toastr";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ExitReasonDetails } from "../../shared/models/ExitReasonDetails";

@Component({
  selector: "app-reason-dialog",
  templateUrl: "./reason-dialog.component.html",
  styleUrls: ["./reason-dialog.component.css"],
})
export class ReasonDialogComponent {
  reason: string;
  offboarding: ExitReasonDetails;
  reasonlist: any[];
  exitcategorylist: any[];
  offboardingForm: FormGroup;
  LoginEmpCode: any;


  constructor(
    private toastr: ToastrService,
    public dialogRef: MatDialogRef<ReasonDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private empsvc: EmployeeService,
    private formBuilder: FormBuilder,
    private userService: UserService
  ) {
    this.exitcategorylist = data.exitcategorylist; 
  }

  ngOnInit() {
    this.LoginEmpCode = this.userService.getEmpCode();
    this.offboardingForm = this.formBuilder.group({
      ExitID: ["", [Validators.required]],
      ExitReasonDetails: ["", [Validators.required]], 
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    const exitID = this.offboardingForm.get('ExitID').value;  
    const exitReasonDetails = this.offboardingForm.get('ExitReasonDetails').value;
    const createdBy = this.LoginEmpCode;
    const modifiedBy = this.LoginEmpCode;

    if (!exitID || !exitReasonDetails) {
      this.toastr.error('Please fill in all the required fields');
      return; 
    }
   
    const reasonData: ExitReasonDetails = {
      ExitID: exitID, 
      ReasonID: 0,
      ExitReasonDetails: exitReasonDetails,
      CreatedBy: createdBy,
      ModifiedBy:modifiedBy,
    };

    this.empsvc.SaveExitReason(reasonData).subscribe(
      (response) => {
        this.toastr.success('Reason saved successfully!');
        this.dialogRef.close(reasonData);  
      },
      (error) => {
        this.toastr.error('Failed to save reason. Please try again.');
      }
    );
  }

  getsavedreasons(reasonid: number) {
    this.empsvc.getReasons().subscribe((data: any) => {
      var category = data.filter((x) => x.ReasonID == reasonid);
      return category[0].ExitReasonDetails;
    });
  }

  getexitreasonbyid() {
    this.empsvc.GetExitReasonByID(1).subscribe();
  }

  getExitReasons() {
    this.empsvc.GetExitReasons().subscribe((data: any) => {
      this.exitcategorylist = data;
    });
  }

  reasons(event: any) {
    if (event == 1) {
      this.empsvc.GetExitReasonByID(event).subscribe((data: any) => {
        this.reasonlist = data;
      });
    } else if (event == 2) {
      this.empsvc.GetExitReasonByID(event).subscribe((data: any) => {
        this.reasonlist = data;
      });
    } else {
      this.empsvc.getReasons().subscribe((data: any) => {
        this.reasonlist = data;
      });
    }
  }

}

